/* eslint-disable import/no-webpack-loader-syntax */
// import ReactDOM from 'react-dom';
import PiwikPro from '@piwikpro/react-piwik-pro';
import { createBrowserHistory } from 'history';
import { omit } from 'ramda';
import qs from 'query-string';
import { appRenderer } from './appRenderer';
import configureStore from './store/configureStore';
import configureMachine from './fsm/fsm';
import coreApiService from './coreApi/coreApiService';
import * as webStorage from './webStorage';
import themeApp from './theme';

import { getDateFnsLocaleData } from './i18n';
import { start } from './fsm/events';
import { getLocale } from './selectors/language';
import { getToken } from './selectors/global';

import ImageFactory from './images/images';
import imageMapping from './images/mapping';

import { isInIframe } from './utils/globals';
import { resolvePersistedState } from './utils/statePersistenceControl';

const fromBase64 = data => JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(data), c => c.charCodeAt(0))));

export default function createApp() {
  const persistedState = resolvePersistedState(localStorage.getItem(webStorage.APP_STATE));
  const hydratedInitialState = persistedState || fromBase64(window.APP_STATE);
  const locale = getLocale(hydratedInitialState);
  const dateFnsLocaleData = getDateFnsLocaleData(locale);
  const settings = fromBase64(window.SETTINGS);
  const messages = window.I18N;
  const history = createBrowserHistory();
  const isEmbed = isInIframe();
  const { PIWIK_SITE_ID } = settings;
  const {
    global: { session, piwikUrl },
  } = hydratedInitialState;

  PiwikPro.initialize(PIWIK_SITE_ID, piwikUrl);

  const previousClaimId = webStorage.getClaimId(session);
  const jwt = webStorage.getJwt(session);

  const initialState = {
    ...hydratedInitialState,
    eligibility: hydratedInitialState.eligibility,
    global: {
      ...hydratedInitialState.global,
      isEmbed,
      mode: hydratedInitialState.global.mode,
    },
    coreApi: {
      ...hydratedInitialState.coreApi,
      ...(previousClaimId && { previousClaimId }),
      ...(jwt && { jwt }),
    },
    settings,
  };
  const machine = configureMachine(initialState, { mode: initialState.global.mode });
  const store = configureStore(initialState, machine);

  const { maxBrandSuggestions, maxModelSuggestions } = coreApiService.config({ ...initialState.coreApi, store });
  if (!maxBrandSuggestions) {
    coreApiService.config({ maxBrandSuggestions: 10000 });
  }

  if (!maxModelSuggestions) {
    coreApiService.config({ maxModelSuggestions: 10000 });
  }

  const params = qs.parse(window.location.search);
  const newQuery = qs.stringify(omit(['session'], params));
  history.replace(`?${newQuery}`);

  const imageFactory = ImageFactory(getToken(store.getState()), imageMapping);
  const MOUNT_NODE = document.getElementById('root');
  const theme = themeApp;
  const renderApp = appRenderer(MOUNT_NODE, store, history, theme, machine, window.CONFIG, imageFactory, dateFnsLocaleData);

  if (window.Intl) {
    renderApp(messages);
  }

  store.dispatch(start());
}
